<template>
    <div class="container">
        <div v-if="!isFormVisible" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> Centros de Trabajo</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="openCreateModal">
                    <span class="fa-solid fa-plus" />
                    Crear
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <CustomFilters
:order-options="orderOptions" :items-per-page="itemsPerPage" :view-as-card="viewAsCard"
                    :show-deleted="showDeleted" @apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
                    @update-view-as-card="updateViewAsCard" @update-show-deleted="updateShowDeleted" />
                <div v-if="loading" class="loading-indicator">
                    <p>Cargando datos...</p>
                </div>
                <div v-else>
                    <div v-if="filteredItems.length === 0" class="no-records p-5 px-4">
                        <p>No se encontraron registros. Intenta ajustar los filtros o añadir nuevos registros.</p>
                    </div>
                    <div v-else>
                        <div v-if="!viewAsCard" class="table-responsive">
                            <GenericTable
:data="filteredItems" :headers="headers" @delete-record="deleteItem"
                                @edit-record="openEditModal" @restore-record="restoreItem" />
                        </div>
                        <transition-group ref="listContainer" name="fade-move" tag="div" class="row me-2 ms-2 pt-2">
                            <template v-if="viewAsCard">
                                <AppCard
v-for="(item) in filteredItems" :key="item.id" ref="listItems" :data="item"
                                    class="fade-card" @delete-record="deleteItem" @edit-record="openEditModal"
                                    @restore-record="restoreItem" />
                            </template>
                        </transition-group>
                        <Pagination
:total-items="totalFilteredItems" :current-page="currentPage" :last-page="lastPage"
                            :items-per-page="itemsPerPage" @page-change="changePage" />
                    </div>
                </div>
            </div>
        </div>
        <ModelModal
v-if="showModal && !displayAsForm" v-model="showModal" :is-edit-mode="isEditMode"
            :resource-api="resourceApi" :entity-data="entityData" :display-as-form="displayAsForm"
            :resource-name="resourceName" @entity-updated="handleEntityUpdated">
            <template #default="{ entity, errors }">
                <div class="mb-3">
                    <label for="name" class="form-label">Nombre del centro de trabajo</label>
                    <input
id="name" v-model="entity.name" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.name }">
                    <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name[0] }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="address" class="form-label">Dirección</label>
                    <input
id="description" v-model="entity.address" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.address }">
                    <div v-if="errors.address" class="invalid-feedback">
                        {{ errors.address[0] }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mb-3">
                        <label for="phone" class="form-label">Teléfonos</label>
                        <input
id="description" v-model="entity.phone" type="text" class="form-control"
                            :class="{ 'is-invalid': errors.phone }">
                        <div v-if="errors.phone" class="invalid-feedback">
                            {{ errors.phone[0] }}
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <label for="photo" class="form-label">Imagen</label>
                        <input
id="description" v-model="entity.photo" type="text" class="form-control"
                            :class="{ 'is-invalid': errors.photo }">
                        <div v-if="errors.photo" class="invalid-feedback">
                            {{ errors.photo[0] }}
                        </div>
                    </div>
                </div>
            </template>
        </ModelModal>
        <div v-if="isFormVisible && displayAsForm" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> {{ isEditMode ? 'Editar' : 'Crear' }} Centro de Trabajo
                </h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="closeForm">
                    <span class="fa-solid fa-arrow-left" />
                    Volver
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <ModelModal
v-model="showModal" :is-edit-mode="isEditMode" :resource-api="resourceApi"
                    :entity-data="entityData" :display-as-form="displayAsForm" :keep-form-open="keepFormOpen"
                    :resource-name="resourceName" @entity-updated="handleEntityUpdated">
                    <template #default="{ entity, errors }">
                        <div class="form-grid">
                            <div class="mb-3">
                                <label for="name" class="form-label">Nombre del centro de trabajo</label>
                                <input
id="name" v-model="entity.name" type="text" class="form-control"
                                    :class="{ 'is-invalid': errors.name }">
                                <div v-if="errors.name" class="invalid-feedback">
                                    {{ errors.name[0] }}
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="address" class="form-label">Dirección</label>
                                <input
id="description" v-model="entity.address" type="text" class="form-control"
                                    :class="{ 'is-invalid': errors.address }">
                                <div v-if="errors.address" class="invalid-feedback">
                                    {{ errors.address[0] }}
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="phone" class="form-label">Teléfonos</label>
                                <input
id="description" v-model="entity.phone" type="text" class="form-control"
                                    :class="{ 'is-invalid': errors.phone }">
                                <div v-if="errors.phone" class="invalid-feedback">
                                    {{ errors.phone[0] }}
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="photo" class="form-label">Imagen</label>
                                <input
id="description" v-model="entity.photo" type="text" class="form-control"
                                    :class="{ 'is-invalid': errors.photo }">
                                <div v-if="errors.photo" class="invalid-feedback">
                                    {{ errors.photo[0] }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ModelModal>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useModelActions } from '@/composables/useModelActions';
import ModelModal from '@/components/ModelModal.vue';
import CustomFilters from '@/components/CustomFilters.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import Pagination from '@/components/Pagination.vue';
import AppCard from './AppCard.vue';
import GenericTable from '@/components/GenericTable.vue';

const resourceApi = 'center-medicals';
const resourceName = 'Centros de Trabajo';

const orderOptions = [
    { text: 'Fecha de modificación', value: 'updated_at' },
    { text: 'Fecha de creación', value: 'created_at' },
    { text: 'Nombre', value: 'name' }
];

const headers = ref([
    { text: 'Nombre', value: 'name' },
    { text: 'Dirección', value: 'address' },
    { text: 'Teléfono', value: 'phone' },
    { text: 'Creación', value: 'created_at' }
]);

const showModal = ref(false);
const isEditMode = ref(false);
const entityData = ref({
    name: '',
    description: '',
    subscription: '',
    active: true
});
const viewAsCard = ref(true);
const showDeleted = ref(false);
const loading = ref(true);
const displayAsForm = ref(false);
const keepFormOpen = ref(true);
const isFormVisible = ref(false);

const {
    openCreateModal,
    openEditModal,
    handleEntityUpdated,
    applyFilter,
    updateItemsPerPage,
    updateViewAsCard,
    updateShowDeleted,
    restoreItem,
    deleteItem,
    fetchItems,
    changePage,
    filteredItems,
    totalFilteredItems,
    currentPage,
    itemsPerPage,
    lastPage
} = useModelActions(resourceApi, {
    showModal,
    isEditMode,
    entityData,
    viewAsCard,
    showDeleted,
    displayAsForm,
    loading,
    isFormVisible,
    keepFormOpen,
    resourceName
});

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems();
});

const closeForm = () => {
    isFormVisible.value = false;
    fetchItems(currentPage.value);
};

</script>

<style scoped>
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}
</style>
